// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3pj4J","head":"Table_head__3KLKs","col":"Table_col__3RbRY"};